<template>
  <div class="col s12">
    <div class="card">
      <div class="card-content">


        <ul class="collection ">

          <li
              v-for="file in files"
              :key="file.Key"
              class="collection-item avatar"
          >

            <i v-if="file.doc_type === 'certificate'" class="material-icons circle blue">verified_user</i>
            <i v-else-if="file.doc_type === 'policy'" class="material-icons circle red">security</i>
            <i v-else-if="file.doc_type === 'receipt'" class="material-icons circle green">attach_money</i>


            <span class="title">{{ file.fileName }} - {{ formatBytes(file.Size) }}</span>
            <p>Caricato il {{ new Date(file.LastModified).toLocaleDateString('it-IT') }} alle {{ new Date(file.LastModified).toLocaleTimeString('it-IT') }}</p>
            <div class="secondary-content">
              <button v-if="uploadEnabled" type="button" class="btn btn-small" @click="deleteFile(file.fileName)"><i class="material-icons">delete</i> Elimina</button>
              <button type="button" class="btn btn-small" @click="downloadFile(file.fileName)"><i class="material-icons">file_download</i> Scarica</button>
            </div>

          </li>

          <li
              v-for="file in uploadedFiles"
              :key="file.name"
              class="collection-item avatar"
          >
            <i class="material-icons circle blue">publish</i>
            <span class="title">{{ file.name }} - {{ formatBytes(file.size) }}<br />
            Sto caricando il file... attendere</span>
          </li>

          <li
              v-if="uploadEnabled"
              class="upload-trigger lighten-4"
              @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <label for="fileUploader"><h3>Per allegare documenti a questa comunicazione<br />
              <span>Trascina un documento qui, <u>clicca qui</u>, oppure premi il pulsante "Sfoglia".</span></h3></label>
            <input id="fileUploader" name="files" type="file" multiple ref="uploadInput" @input="choosed" />

            <span @click="cleanFileUpload">Rimuovi file caricati</span>
          </li>

        </ul>
      </div>
    </div>
  </div>

</template>
<script>

import Vue from 'vue';
import filesaver from 'file-saver';

export default {
  name: 'DirectoryUplaoder',

  props: {
    files: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    entity_id: {
      required: true,
      type: Number
    },
    uploadEnabled: {
      required: false,
      type: Boolean
    },
  },

  data() {
    return {
      saveButton: null,
      uploadedFiles: [],
      msecondsElapsed: 0,
    }
  },

  methods: {

    formatBytes: function (bytes, decimals = 1, k = 1024) {
      if (bytes === 0) return '0 Bytes';

      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },

    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('green')) {
        event.currentTarget.classList.add('green');
      }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('green');
    },
    drop(event) {
      event.preventDefault();
      // console.log('Dropped files', event.dataTransfer.files)
      this.$refs.uploadInput.files = event.dataTransfer.files;
      Vue.set(this,'uploadFiles',this.$refs.uploadInput.files);
      // Clean up
      event.currentTarget.classList.remove('green');
      this.fileUploaded();
    },

    choosed: function () {
      // console.log('FILE from computer selected by browse button', this.$refs.uploadInput.files);
      Vue.set(this,'uploadedFiles',this.$refs.uploadInput.files);
      this.fileUploaded();
    },

    // Handle the real file drop action, equal to "browse" action finished and file selected
    fileUploaded() {

      this.msecondsElapsed = new Date().getMilliseconds();

      let formData = new FormData();

      formData.append('id', this.entity_id);

      for (let file of this.uploadedFiles) {
        formData.append('files[]', file);
      }

      window.axios.post('/index.php?option=com_api&app=asdgest&resource=communication', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then( this.onFileUpload )
        .catch( this.onFileUploadError )
    },

    onFileUpload: function(response) {
      // console.log('File upload 200', response)

      const now = new Date().getMilliseconds();
      const msTarget = 2000;

      if ( this.msecondsElapsed + msTarget <= now) {
        // late: request take more then 2 seconds
        this.cleanFileUpload(response);
      }
      else {
        window.setTimeout( () => {
          this.cleanFileUpload(response);
        }, Math.min(500, 200-this.msecondsElapsed) );
      }
    },

    onFileUploadError: function( error ) {
      console.log('File upload ERROR', error);
      alert('Qualcosa non ha funzionato');
    },

    cleanFileUpload: function (response) {

      if (response.hasOwnProperty('data')) {
        response.data.files.forEach( x => {
          this.files.push({
            fileName: x.name,
            Size: x.size,
            LastModified: x.date,
          })
        })
      }

      this.$refs.uploadInput.value = null;
      Vue.set(this, 'uploadedFiles', []);
    },

    downloadFile: function( name ) {
      window.axios.get('/index.php?option=com_api&app=asdgest&resource=communication&id='+this.entity_id+'&filename='+name, {
        responseType: 'blob'
      })
          .then( async response => {
            // console.log(response);
            if (response.headers['content-type'] === 'application/json') {
              let data = await response.data.text();
              const {message, code} = JSON.parse(data);
              if (code === 401) {
                alert(message);
              } else {
                alert('Qualcosa è andato storto: '+message);
              }
            } else {
              filesaver.saveAs( response.data, name);
            }

          } )
          .catch( error => {
            console.log(error);
            alert('Qualcosa è andato storto: '+error.data.message);
          });

    },

    deleteFile: function( name ) {
      if (confirm('Sei sicuro di voler eliminare questo file? È un azione non ripristinabile')) {
        window.axios({
          url: '/index.php?option=com_api&app=asdgest&resource=communication',
          method: 'delete',
          data: {
            id: this.entity_id,
            filename: name,
          }
        })
            .then ( response => {
              if (response.hasOwnProperty('data') && response.data.hasOwnProperty('ok') && response.data.ok === true) {
                alert('Eliminazione avvenuta. Ricarica la pagina');
              }
              else {
                let message = response.data.message;
                alert('Eliminazione non avvenuta: '+message);
              }
            })
            .catch ( error => {
              console.log(error);
              alert('Eliminazione non avvenuta. Errore');
            });
      } else {
        console.log('Cancellazione annullata');
      }
    },
  },

}

</script>
<style lang="scss">
.upload-trigger {
  padding: 15px;
  text-align: center;
  h3 {
    margin-top: 0;
    font-size: 20px;
  }
}
</style>
